import { useEffect, useState } from "react";
import { useFetcher, useSearchParams } from "react-router";

import {
  useContentfulInspectorMode,
  useContentfulLiveUpdates,
} from "@contentful/live-preview/react";
import { CookieIcon } from "@radix-ui/react-icons";

import { RichTextRender } from "~/contentful/components/rich-text";
import { cn } from "~/lib/ui";

import { useCookieBanner } from "../cookie";

export default function CookieBanner() {
  const cookieBannerContent = useCookieBanner();
  const [searchParams] = useSearchParams();
  const preview = !!searchParams.get("preview");
  const liveContent = useContentfulLiveUpdates(cookieBannerContent);
  const cookieBannerData = preview ? liveContent : cookieBannerContent;
  const fetcher = useFetcher();
  const [showBanner, setShowBanner] = useState<boolean>();
  const inspectorProps = useContentfulInspectorMode();

  useEffect(() => {
    setShowBanner(cookieBannerData?.showCookieBanner);
  }, [cookieBannerData?.showCookieBanner]);

  return (
    cookieBannerData?.cookieData.fields.showCookieBanner && (
      <div className={cn(!showBanner && "hidden")}>
        <section className="fixed bottom-0 z-50 mx-auto max-w-2xl rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900 sm:bottom-16 sm:left-12 md:flex md:items-center md:gap-x-4">
          <div className="flex items-center gap-x-4">
            <span className="inline-flex shrink-0 rounded-lg bg-blue-100/80 p-2 text-blue-500 dark:bg-gray-800">
              <CookieIcon />
            </span>

            <span
              className="text-sm text-gray-600 dark:text-gray-300"
              {...inspectorProps({
                entryId: cookieBannerData?.cookieData.sys.id,
                fieldId: "name",
              })}
            >
              <RichTextRender
                entryId={cookieBannerData?.cookieData.sys.id}
                content={cookieBannerData?.cookieData.fields.content}
              />
            </span>
          </div>

          <div className="mt-6 flex shrink-0 items-center gap-x-4 lg:mt-0">
            <fetcher.Form method="post" action="/resources/cookie">
              <input type="hidden" name="bannerVisibility" value="visible" />
              <button
                type="submit"
                onClick={() => setShowBanner(false)}
                className="w-1/2 text-xs text-gray-800 underline transition-colors duration-300 hover:text-gray-600 focus:outline-none dark:text-white dark:hover:text-gray-400 md:w-auto"
              >
                Reject
              </button>
            </fetcher.Form>
            <fetcher.Form method="post" action="/resources/cookie">
              <input type="hidden" name="bannerVisibility" value="hidden" />
              <button
                type="submit"
                onClick={() => setShowBanner(false)}
                className="w-1/2 w-auto rounded-lg bg-gray-800 px-4 py-2.5 text-xs font-medium text-white transition-colors duration-300 hover:bg-gray-700 focus:outline-none"
              >
                Accept
              </button>
            </fetcher.Form>
          </div>
        </section>
      </div>
    )
  );
}
